import { render, staticRenderFns } from "./currency-exchange-trade-1.vue?vue&type=template&id=9c1fe89e&"
import script from "./currency-exchange-trade-1.vue?vue&type=script&lang=ts&"
export * from "./currency-exchange-trade-1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports